import { useEffect, useState } from 'react'

const useEventListener = () => {
   const [isAlmostExit, setIsAlmosExit] = useState(false)

   useEffect(() => {
      let prev: number | null = null
      const onAlmostExit = (e: MouseEvent) => {
         if (e.clientY < 15) {
            if (prev && prev > e.clientY) {
               setIsAlmosExit(true)
            }
         } else {
            setIsAlmosExit(false)
         }
         prev = e.clientY
      }
      window.addEventListener('mousemove', onAlmostExit, false)
      return () => {
         window.removeEventListener('mousemove', onAlmostExit, false)
      }
   }, [])

   const clear = () => {
      setIsAlmosExit(false)
   }

   return [isAlmostExit, clear]
}

export default useEventListener
